import { describeResource } from '@siteless/resource';
import { collection, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

const AllBallotsResource = describeResource('AllBallots', {
  get: async () => {
    const ballots = {};

    (await getDocs(collection(database, `ballots_${thisOscarsYear}`))).forEach(
      (document) => {
        ballots[document.id] = document.data();
      },
    );

    return ballots;
  },
});

export default AllBallotsResource;
